import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { nextTick, onMounted, onUnmounted, ref, watch } from "vue";
import * as echarts from "echarts";
import "echarts-liquidfill";
export default {
  __name: 'index',
  props: {
    option: {
      type: Object,
      required: true
    },
    theme: {
      type: [String, Object],
      default: undefined
    }
  },
  setup(__props) {
    const props = __props;
    const chartRef = ref(null);
    let chartInstance = null;
    let resizeObserver = null;
    const initChart = () => {
      if (!chartRef.value) {
        return;
      }
      if (!chartInstance) {
        chartInstance = echarts.init(chartRef.value, props.theme);
      }
    };
    const updateChart = () => {
      if (!props.option) {
        return;
      }
      initChart();
      if (chartInstance) {
        chartInstance.setOption(props.option, true);
      }
    };
    const resizeChart = () => {
      if (chartInstance) {
        chartInstance.resize();
      }
    };
    watch(() => props.option, () => {
      nextTick(() => {
        updateChart();
      });
    }, {
      deep: true
    });
    watch(() => props.theme, () => {
      if (chartInstance) {
        chartInstance.dispose();
        chartInstance = null;
      }
      nextTick(() => {
        updateChart();
      });
    });
    onMounted(() => {
      nextTick(() => {
        updateChart();
        if (typeof ResizeObserver !== "undefined" && chartRef.value) {
          resizeObserver = new ResizeObserver(() => {
            resizeChart();
          });
          resizeObserver.observe(chartRef.value);
        } else {
          window.addEventListener("resize", resizeChart);
        }
      });
    });
    onUnmounted(() => {
      if (resizeObserver) {
        resizeObserver.disconnect();
      } else {
        window.removeEventListener("resize", resizeChart);
      }
      if (chartInstance) {
        chartInstance.dispose();
        chartInstance = null;
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        ref_key: "chartRef",
        ref: chartRef,
        class: "echarts-wrap"
      }, null, 512);
    };
  }
};